import React, { Component } from 'react'
import EkoModal from '../../components/elements/EkoModal'

class ImportDetailModal4 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saving: false
        }
    }

    closeModal() {
        this.props.closeModal();
    }

    render() {
        return (
            <EkoModal
                showModal={this.props.showModal}
                title={"Ödemeler"}
                onHide={this.closeModal.bind(this)}
                spinner={this.state.saving}>
                {/* Modal içeriği boş - iframe ile doldurulacak */}
            </EkoModal>
        )
    }
}

export default ImportDetailModal4;